import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService, GetCalendarYearsResponse } from '@app/shared';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-calendar-years',
  templateUrl: './calendar-years.component.html',
  styleUrls: ['./calendar-years.component.scss']
})
export class CalendarYearsComponent implements OnInit {

  years$!: Observable<GetCalendarYearsResponse[]>;
  private refreshTrigger$ = new BehaviorSubject<void>(undefined);

  private today!: dayjs.Dayjs;

  constructor(private route: ActivatedRoute, private apiService: ApiService) { }

  ngOnInit(): void {
    this.today = dayjs();
    this.years$ = this.refreshTrigger$.pipe(
      switchMap(() => this.apiService.calendarGetYears())
    );
    // Initialize with route data if available
    this.route.data.pipe(map(({years}) => years)).subscribe(years => {
      // Trigger initial load
      this.refreshData();
    });
  }

  private refreshData(): void {
    this.refreshTrigger$.next();
  }

  startNewYear() {
    const year = this.today.year();
    const msg = `Zaceto bo novo solsko leto ${year}/${year + 1}`;
    if (!confirm(msg)) {
      return;
    }
    this.apiService.calendarCreateYear(year).subscribe((rv: any) => {
      console.log(rv);
      this.refreshData(); // Refresh the data after successful creation
    });
  }

  // Check if we can start a new year (the current year does not exist yet)
  canStartYear(years: GetCalendarYearsResponse[]) {
    return !years.find(({year}) => year === this.today.year());
  }

  // Check if we can activate the given year (it is the target year and exists)
  canActivateYear(targetYear: number): boolean {
    const thisMonth = this.today.month();
    let currSchoolYear = this.today.year();

    // If before September (months start at 0), we are still in the previous school year
    if (thisMonth < 8)  {
      currSchoolYear -= 1;
    }

    return (targetYear === currSchoolYear || targetYear === currSchoolYear - 1 || targetYear === currSchoolYear + 1);
  }

  activateYear(year: number) {
    const msg = `Aktivirano leto bo ${year}/${year + 1}.\nSte prepričani?`;
    if (!confirm(msg)) {
      return;
    }
    this.apiService.calendarCreateYear(year).subscribe((rv: any) => {
      console.log(rv);
      this.refreshData(); // Refresh the data after successful activation
    });
  }
}
